class Service {}

export default Service;
